import React, { useState, useEffect, useCallback } from 'react';
import { useMusicPlayer } from '../context/MusicPlayerContext';
import axios from 'axios';
import ReactPaginate from 'react-paginate';

// Music API service
const MusicAPI = {
  getAllSongs: async (page = 1, limit = 50) => {
    try {
      const response = await axios.get(`https://api.samasong.com/sama-music/musics/getAll?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching songs:', error);
      throw error;
    }
  },
  
  getAllCategories: async () => {
    try {
      const response = await axios.get(`https://api.samasong.com/sama-music/categories/getAll`);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },
  
  searchSongs: async (query, page = 1, limit = 50) => {
    try {
      const response = await axios.get(`https://samamusic.onrender.com/sama-music/musics/search?query=${query}&page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error searching songs:', error);
      throw error;
    }
  },
  
  getSubcategoriesByCategory: async (categoryId) => {
    try {
      const response = await axios.get(`https://samamusic.onrender.com/sama-music/subCategories/getAll?categoryId=${categoryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      throw error;
    }
  }
};

// Simple icon components as fallback
const Icon = {
  Search: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
    </svg>
  ),
  X: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
  ),
  Music: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z" clipRule="evenodd" />
    </svg>
  ),
  Folder: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
    </svg>
  ),
  AlertCircle: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
    </svg>
  ),
  ArrowLeft: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
    </svg>
  ),
  Play: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
    </svg>
  ),
  Pause: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
    </svg>
  ),
  SkipBack: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.445 14.832A1 1 0 0010 14v-2.798l5.445 3.63A1 1 0 0017 14V6a1 1 0 00-1.555-.832L10 8.798V6a1 1 0 00-1.555-.832l-6 4a1 1 0 000 1.664l6 4z" />
    </svg>
  ),
  SkipForward: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.555 5.168A1 1 0 003 6v8a1 1 0 001.555.832L10 11.202V14a1 1 0 001.555.832l6-4a1 1 0 000-1.664l-6-4A1 1 0 0010 6v2.798l-5.445-3.63z" />
    </svg>
  ),
  Volume2: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z" clipRule="evenodd" />
    </svg>
  ),
  Volume1: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0A3.986 3.986 0 0115 10a3.986 3.986 0 01-1.293 2.707 1 1 0 01-1.414-1.414A1.986 1.986 0 0013 10c0-.553-.223-1.051-.586-1.414a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
  ),
  VolumeX: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
  )
};

export default function Search() {
  const { playSong, currentSong, isPlaying } = useMusicPlayer();
  
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allSongs, setAllSongs] = useState([]);


  
  const [error, setError] = useState(null);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalSongs, setTotalSongs] = useState(0);
  const songsPerPage = 10;

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchAllSongs(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Fetch all songs
  const fetchAllSongs = useCallback(async (page = 1) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await MusicAPI.getAllSongs(page, songsPerPage);
      console.log('All songs response:', response);
      
      if (response.success && response.data) {
        let songsData = [];
        
        if (response.data.data && Array.isArray(response.data.data)) {
          songsData = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          songsData = response.data;
        } else if (Array.isArray(response.data)) {
          songsData = response.data;
        }
        
        setAllSongs(songsData);
        
        // Set pagination info
        const total = response.data.totalCount || response.data.total || songsData.length;
        setTotalSongs(total);
        setTotalPages(Math.ceil(total / songsPerPage));
        
        console.log('Songs loaded:', songsData.length);
      } else {
        console.warn('Unexpected response structure:', response);
        setAllSongs([]);
      }
    } catch (error) {
      console.error('Error fetching all songs:', error);
      setError('Failed to load songs');
      setAllSongs([]);
    } finally {
      setIsLoading(false);
    }
  }, []);


  // Fetch all songs on component mount
  useEffect(() => {
    fetchAllSongs(currentPage);
  }, [currentPage, fetchAllSongs]);

  // Handle search
  const handleSearch = async (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      console.log('Searching for:', query);
      
      const response = await MusicAPI.searchSongs(query);
      console.log('Search response:', response);
      
      if (response.success) {
        let results = [];
        
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          results = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          results = response.data;
        } else if (Array.isArray(response.data)) {
          results = response.data;
        } else if (Array.isArray(response)) {
          results = response;
        }
        
        setSearchResults(results);
        console.log('Search results:', results.length, 'songs');
        
        if (results.length === 0) {
          const filtered = allSongs.filter(song => {
            const songTitle = song.title || song.name || '';
            const songArtist = song.artist || song.artists || '';
            const songDescription = song.description || '';
            
            const queryLower = query.toLowerCase();
            return (
              songTitle.toLowerCase().includes(queryLower) ||
              (typeof songArtist === 'string' && songArtist.toLowerCase().includes(queryLower)) ||
              (Array.isArray(songArtist) && songArtist.some(artist => 
                artist.toLowerCase().includes(queryLower)
              )) ||
              songDescription.toLowerCase().includes(queryLower)
            );
          });
          
          if (filtered.length > 0) {
            setSearchResults(filtered);
            console.log('Local filtered results:', filtered.length, 'songs');
          }
        }
      } else {
        console.log('Search API failed, using local filtering');
        const filtered = allSongs.filter(song => {
          const songTitle = song.title || song.name || '';
          const songArtist = song.artist || song.artists || '';
          const songDescription = song.description || '';
          
          const queryLower = query.toLowerCase();
          return (
            songTitle.toLowerCase().includes(queryLower) ||
            (typeof songArtist === 'string' && songArtist.toLowerCase().includes(queryLower)) ||
            (Array.isArray(songArtist) && songArtist.some(artist => 
              artist.toLowerCase().includes(queryLower)
            )) ||
            songDescription.toLowerCase().includes(queryLower)
          );
        });
        setSearchResults(filtered);
        console.log('Fallback search results:', filtered.length, 'songs');
      }
    } catch (error) {
      console.error('Error searching:', error);
      setError('Search failed. Using local results.');
      
      const filtered = allSongs.filter(song => {
        const songTitle = song.title || song.name || '';
        const songArtist = song.artist || song.artists || '';
        const songDescription = song.description || '';
        
        const queryLower = query.toLowerCase();
        return (
          songTitle.toLowerCase().includes(queryLower) ||
          (typeof songArtist === 'string' && songArtist.toLowerCase().includes(queryLower)) ||
          (Array.isArray(songArtist) && songArtist.some(artist => 
            artist.toLowerCase().includes(queryLower)
          )) ||
          songDescription.toLowerCase().includes(queryLower)
        );
      });
      setSearchResults(filtered);
      console.log('Error fallback results:', filtered.length, 'songs');
    } finally {
      setIsLoading(false);
    }
  }

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      handleSearch(searchQuery);
    }
  };


  // Handle clear search
  const handleClearSearch = () => {
    setSearchQuery('');
    setSearchResults([]);
    setError(null);
  };

  // Handle song click - using centralized music player
  const handleSongClick = (song) => {
    try {
      // Format song data to match expected structure
      const formattedSong = {
        id: song._id || song.id,
        title: song.title || song.name || 'Unknown Song',
        artist: song.artist || song.artists || 'Unknown Artist',
        album: song.album || 'Unknown Album',
        cover: song.image || song.thumbnail || '/default-cover.jpg',
        audioUrl: song.audioUrl || song.audio || song.url || song.musicUrl || song.fileUrl,
        duration: song.duration || '3:20',
        plays: song.playCount || song.plays || 0,
        category: song.category || 'General'
      };

      // Use the current search results or all songs as playlist
      const currentList = searchQuery.trim() ? searchResults : allSongs;
      const formattedList = currentList.map(s => ({
        id: s._id || s.id,
        title: s.title || s.name || 'Unknown Song',
        artist: s.artist || s.artists || 'Unknown Artist',
        album: s.album || 'Unknown Album',
        cover: s.image || s.thumbnail || '/default-cover.jpg',
        audioUrl: s.audioUrl || s.audio || s.url || s.musicUrl || s.fileUrl,
        duration: s.duration || '3:20',
        plays: s.playCount || s.plays || 0,
        category: s.category || 'General'
      }));

      // Play the song using centralized music player
      playSong(formattedSong, formattedList);
      console.log('Now playing:', formattedSong.title);
    } catch (error) {
      console.error('Error playing song:', error);
      setError('Failed to play song');
    }
  };

  return (
    <div className="space-y-4 xs:space-y-6 sm:space-y-8 px-0 pb-24">
      
      {/* Error Display */}
      {error && (
        <div className="mx-2 xs:mx-3 sm:mx-4 md:mx-0">
          <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-lg">
            <div className="flex items-center">
              <Icon.AlertCircle className="w-5 h-5 mr-2" />
              <span>{error}</span>
            </div>
          </div>
        </div>
      )}
      
      {/* Enhanced Hero Search Section */}
      <div className="relative py-8 sm:py-12 md:py-16 px-2 xs:px-3 sm:px-4 md:px-0">
        <div className="text-center mb-8">
          <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-6xl font-bold bg-gradient-to-r from-white via-purple-200 to-fuchsia-200 bg-clip-text text-transparent mb-4">
            Search Music
          </h1>
          <p className="text-slate-400 text-sm xs:text-base sm:text-lg max-w-2xl mx-auto">
            Discover millions of songs, artists, and albums from around the world
          </p>
        </div>

        {/* Enhanced Search Bar */}
        <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto">
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-fuchsia-500/20 to-purple-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
            <div className="relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden">
              <div className="flex items-center">
                <div className="flex-1 flex items-center">
                  <Icon.Search className="w-5 h-5 sm:w-6 sm:h-6 text-slate-400 ml-4 mr-3" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchQuery(value);
                      if (value.trim()) {
                        handleSearch(value);
                      } else {
                        setSearchResults([]);
                      }
                    }}
                    placeholder="Search for songs, artists, or albums..."
                    className="w-full py-4 sm:py-5 bg-transparent text-white placeholder-slate-400 focus:outline-none text-sm sm:text-base"
                  />
                </div>
                {searchQuery && (
                  <button
                    type="button"
                    onClick={handleClearSearch}
                    className="p-3 mr-2 text-slate-400 hover:text-white transition-colors"
                  >
                    <Icon.X className="w-4 h-4 sm:w-5 sm:h-5" />
                  </button>
                )}
                <button
                  type="submit"
                  className="px-4 sm:px-6 py-4 sm:py-5 bg-gradient-to-r from-fuchsia-500 to-purple-500 text-white font-medium hover:opacity-90 transition-opacity"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* Loading State */}
      {isLoading && (
        <div className="flex flex-col justify-center items-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-fuchsia-500 mb-4"></div>
          <p className="text-slate-400">Loading music...</p>
        </div>
      )}


      {/* Enhanced Search Results - Card Layout */}
      {!isLoading && searchQuery && (
        <div className="space-y-6 px-2 xs:px-3 sm:px-4 md:px-0">
          <div className="flex items-center justify-between">
            <h2 className="text-xl xs:text-2xl sm:text-3xl font-bold bg-gradient-to-r from-white to-purple-200 bg-clip-text text-transparent">
              Search Results for "{searchQuery}"
            </h2>
            <span className="px-3 py-1 bg-fuchsia-500/20 text-fuchsia-300 rounded-full text-sm">
              {searchResults.length} {searchResults.length === 1 ? 'song' : 'songs'}
            </span>
          </div>
          
          {searchResults.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {searchResults.map((song, index) => (
                <div
                  key={song._id || index}
                  className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:border-fuchsia-500/40 hover:bg-white/10 transition-all duration-500 cursor-pointer"
                  onClick={() => handleSongClick(song)}
                >
                  <div className="relative aspect-square overflow-hidden">
                    <img
                      src={song.image || song.thumbnail || 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop'}
                      alt={song.name || song.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      onError={(e) => {
                        e.target.src = 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop';
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    
                    {/* Play Button Overlay */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSongClick(song);
                        }}
                        className="w-12 h-12 bg-fuchsia-500/90 hover:bg-fuchsia-500 rounded-full flex items-center justify-center backdrop-blur-sm transform scale-90 group-hover:scale-100 transition-all duration-300"
                      >
                        {currentSong && (currentSong.id === song._id || currentSong.id === song.id) && isPlaying ? (
                          <Icon.Pause className="w-6 h-6 text-white" />
                        ) : (
                          <Icon.Play className="w-6 h-6 text-white ml-0.5" />
                        )}
                      </button>
                    </div>

                    {/* Playing Indicator */}
                    {currentSong && (currentSong.id === song._id || currentSong.id === song.id) && isPlaying && (
                      <div className="absolute top-3 right-3">
                        <div className="flex space-x-1">
                          <div className="w-1 h-4 bg-fuchsia-400 rounded-full animate-pulse"></div>
                          <div className="w-1 h-6 bg-fuchsia-400 rounded-full animate-pulse" style={{animationDelay: '0.1s'}}></div>
                          <div className="w-1 h-3 bg-fuchsia-400 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="p-4">
                    <h3 className="font-semibold text-white truncate group-hover:text-fuchsia-400 transition-colors">
                      {song.title || song.name || 'Untitled Song'}
                    </h3>
                    <p className="text-sm text-slate-400 truncate mt-1">
                      {song.artist || song.artists || song.description || 'Unknown Artist'}
                    </p>
                    <div className="flex items-center justify-between mt-3">
                      <span className="text-xs text-slate-500">
                        {song.duration || '3:45'}
                      </span>
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSongClick(song);
                        }}
                        className="p-2 bg-white/10 hover:bg-fuchsia-500/20 rounded-full transition-all duration-300"
                      >
                        {currentSong && (currentSong.id === song._id || currentSong.id === song.id) && isPlaying ? (
                          <Icon.Pause className="w-4 h-4 text-fuchsia-400" />
                        ) : (
                          <Icon.Play className="w-4 h-4 text-slate-400 hover:text-fuchsia-400" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-slate-700 to-slate-800 rounded-3xl flex items-center justify-center">
                <Icon.Search className="w-12 h-12 text-slate-400" />
              </div>
              <h3 className="text-2xl font-medium text-slate-300 mb-3">No songs found</h3>
              <p className="text-slate-400 max-w-md mx-auto">
                We couldn't find any songs matching "{searchQuery}". Try different keywords or browse all songs.
              </p>
            </div>
          )}
        </div>
      )}

      {/* Enhanced All Songs - Card Layout */}
      {!searchQuery && allSongs.length > 0 && !isLoading && (
        <div className="space-y-6 px-2 xs:px-3 sm:px-4 md:px-0">
          <div className="flex items-center justify-between">
            <h2 className="text-xl xs:text-2xl sm:text-3xl font-bold bg-gradient-to-r from-white to-purple-200 bg-clip-text text-transparent">
              All Songs
            </h2>
            <span className="px-3 py-1 bg-fuchsia-500/20 text-fuchsia-300 rounded-full text-sm">
              {allSongs.length} songs
            </span>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {allSongs.map((song, index) => (
              <div
                key={song._id || index}
                className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:border-fuchsia-500/40 hover:bg-white/10 transition-all duration-500 cursor-pointer"
                onClick={() => handleSongClick(song)}
              >
                <div className="relative aspect-square overflow-hidden">
                  <img
                    src={song.image || song.thumbnail || 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop'}
                    alt={song.title || song.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  
                  {/* Play Button Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSongClick(song);
                      }}
                      className="w-12 h-12 bg-fuchsia-500/90 hover:bg-fuchsia-500 rounded-full flex items-center justify-center backdrop-blur-sm transform scale-90 group-hover:scale-100 transition-all duration-300"
                    >
                      {currentSong && (currentSong.id === song._id || currentSong.id === song.id) && isPlaying ? (
                        <Icon.Pause className="w-6 h-6 text-white" />
                      ) : (
                        <Icon.Play className="w-6 h-6 text-white ml-0.5" />
                      )}
                    </button>
                  </div>

                  {/* Playing Indicator */}
                  {currentSong && (currentSong.id === song._id || currentSong.id === song.id) && isPlaying && (
                    <div className="absolute top-3 right-3">
                      <div className="flex space-x-1">
                        <div className="w-1 h-4 bg-fuchsia-400 rounded-full animate-pulse"></div>
                        <div className="w-1 h-6 bg-fuchsia-400 rounded-full animate-pulse" style={{animationDelay: '0.1s'}}></div>
                        <div className="w-1 h-3 bg-fuchsia-400 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
                      </div>
                    </div>
                  )}

                  {/* Index Number */}
                  <div className="absolute top-3 left-3">
                    <span className="text-xs text-white/70 bg-black/30 px-2 py-1 rounded-full backdrop-blur-sm">
                      {index + 1}
                    </span>
                  </div>
                </div>
                
                <div className="p-4">
                  <h3 className="font-semibold capitalize text-white truncate group-hover:text-fuchsia-400 transition-colors">
                    {song.title || song.name || 'Untitled Song'}
                  </h3>
                  <p className="text-sm capitalize text-slate-400 truncate mt-1">
                    {song.artist || song.artists || song.description || 'Unknown Artist'}
                  </p>
                  <div className="flex items-center justify-between mt-3">
                    <span className="text-xs text-slate-500">
                      {song.duration || '3:45'}
                    </span>
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSongClick(song);
                      }}
                      className="p-2 bg-white/10 hover:bg-fuchsia-500/20 rounded-full transition-all duration-300"
                    >
                      {currentSong && (currentSong.id === song._id || currentSong.id === song.id) && isPlaying ? (
                        <Icon.Pause className="w-4 h-4 text-fuchsia-400" />
                      ) : (
                        <Icon.Play className="w-4 h-4 text-slate-400 hover:text-fuchsia-400" />
                      )}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Pagination with react-paginate */}
          {totalPages > 1 && (
            <div className="mt-8 flex flex-col items-center gap-4">
              <ReactPaginate
                previousLabel={'← Previous'}
                nextLabel={'Next →'}
                breakLabel={'...'}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(event) => handlePageChange(event.selected + 1)}
                forcePage={currentPage - 1}
                containerClassName={'flex flex-wrap items-center justify-center gap-2'}
                pageClassName={''}
                pageLinkClassName={'px-4 py-2 bg-white/10 hover:bg-white/20 rounded-xl transition-all duration-300 text-sm'}
                activeClassName={''}
                activeLinkClassName={'!bg-fuchsia-500 text-white'}
                previousClassName={''}
                previousLinkClassName={'px-4 py-2 bg-white/10 hover:bg-white/20 rounded-xl transition-all duration-300 text-sm disabled:opacity-50'}
                nextClassName={''}
                nextLinkClassName={'px-4 py-2 bg-white/10 hover:bg-white/20 rounded-xl transition-all duration-300 text-sm disabled:opacity-50'}
                breakClassName={''}
                breakLinkClassName={'px-4 py-2 text-slate-400'}
                disabledClassName={'opacity-50 cursor-not-allowed'}
              />
              <span className="text-sm text-slate-400">
                Page {currentPage} of {totalPages} ({totalSongs} songs)
              </span>
            </div>
          )}
        </div>
      )}

      {/* No Content Message */}
      {!searchQuery && allSongs.length === 0 && !isLoading && (
        <div className="text-center py-20 px-4">
          <Icon.Music className="w-12 h-12 text-slate-400 mx-auto mb-4" />
          <p className="text-slate-400">No songs available at the moment.</p>
          <button 
            onClick={fetchAllSongs}
            className="mt-4 px-4 py-2 bg-fuchsia-500 text-white rounded-lg hover:bg-fuchsia-600 transition-colors"
          >
            Try Again
          </button>
        </div>
      )}
    </div>
  );
}